import Select from './Select.vue';
import Option from './Option.vue';

export default function install(Vue) {
  Vue.component(Select.name, Select);
  Vue.component(Option.name, Option);
}
